import { FC } from "react";

import Modal from "shared/ui/modal";
import { getS3AssetPath } from "shared/lib/helpers";
import { Button } from "shared/ui/shadcn/button";
import { ValueOfObjectFields } from "shared/lib/interfaces/utils";

interface MicrophoneAccessModalPropsI {
  mode?: ValueOfObjectFields<typeof MICROPHONE_ACCESS_MODES>;
}

export const MICROPHONE_ACCESS_MODES = {
  CALLS: "calls",
};

export const MICROPHONE_ACCESS_MODAL_MODE_DESCRIPTIONS = {
  [MICROPHONE_ACCESS_MODES.CALLS]:
    "To make calls on the platform, you must turn your microphone on.",
};

export const MICROPHONE_ACCESS_MODAL_ID = "microphone-access-modal";

export const MicrophoneAccessModal: FC<MicrophoneAccessModalPropsI> = ({
  mode = MICROPHONE_ACCESS_MODES.CALLS,
}) => (
  <Modal
    id={MICROPHONE_ACCESS_MODAL_ID}
    modalBoxClassName="w-[350px] flex flex-col gap-2.5"
    showCloseButton={false}
  >
    {({ handleClose }) => (
      <>
        <img
          alt="Glencoco Microphone Permission"
          src={getS3AssetPath("platform/permissions/microphone/glenx.webp")}
        />

        <h3 className="mt-1 typography-body-3-medium">
          Enable your microphone
        </h3>
        <p className="text-[#777] typography-body-3">
          {MICROPHONE_ACCESS_MODAL_MODE_DESCRIPTIONS[mode]}
        </p>

        <Button onClick={handleClose}>Got it</Button>
      </>
    )}
  </Modal>
);
